var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"columns",class:{
    [_vm.$style.container]: true,
    [_vm.$style.container__selected]: _vm.selected
  },on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('toggle')}}},[_c('div',{staticClass:"column"},[_c('div',{class:_vm.$style.cardContainer},[_c('SuggestedDocumentCard',{attrs:{"document":_vm.document}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }